<ul class="w-full  divide-y divide-gray-200 cursor-pointer select-none" role="list">
  @for (dataset of percentUiControllerService.datasets; track $index) {
    <ng-container>
      <!--cursor-pointer (mouseover)="mouseover(dataset.id)" , 'hover:bg-gray-200 hover:text-black ':selectedId!==dataset.id-->
      @if (dataset.isActive) {
        <!-- `rounded-md` (Tailwind, .375rem) replaces `rounded-2` (Bootstrap `var(--bs-border-radius)`,
             also .375rem, but `!important`) — Bug #234. Same radius, so no visual change; it is only ever
             visible on the selected row, which is the one that paints a `bg-gray-900` surface. -->
        <li (click)="clicked(dataset.index)"
            [ngClass]="{'bg-gray-900 text-white': selectedId===dataset.index}"
            class="relative w-full flex rounded-md gap-x-6 py-2">
          <div class="grid grid-rows-2 grid-cols-1 px-4 w-full ">
            <div class="flex justify-between items-center  font-medium">
              <span class="font-medium select-none">{{ dataset.name }}</span>
              @if (dataset.revenue) {
                <span class="font-medium select-none">{{ dataset.revenue | currency: "EUR" }}</span>
              }
            </div>
            <div class=" w-full">
              <!-- [mouseOver]="mouseoverId === dataset.id" -->
              <analytics-percent-bar [percent]="dataset.percent" class="w-full select-none"></analytics-percent-bar>
            </div>
          </div>
        </li>
      }
    </ng-container>
  }
</ul>



